const SKELETON_BASE = 'animate-pulse rounded bg-muted';

/** The card list while it loads, at the same count the page asks the API for. */
export const EmployeesMobileListSkeleton = (): React.ReactElement => (
  <div className="flex flex-col gap-3" data-testid="employees-mobile-skeleton">
    {Array.from({ length: 10 }).map((_, index) => (
      <div className="flex items-start gap-3 rounded-lg border border-border p-4" key={index}>
        <div className={`${SKELETON_BASE} size-4 shrink-0`} />
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <div className={`${SKELETON_BASE} h-4 w-40 max-w-full`} />
          <div className={`${SKELETON_BASE} h-4 w-56 max-w-full`} />
          <div className={`${SKELETON_BASE} h-5 w-24 max-w-full`} />
        </div>
      </div>
    ))}
  </div>
);
